import { TApplicationStage } from '../../../Customers.types';

export const SellerActions = ({
  applicationStage,
}: {
  applicationStage?: TApplicationStage['value'];
}) => {
  const getText = () => {
    switch (applicationStage) {
      case 'business_details':
        return 'Remind your customer to finish submitting all of their business information';
      case 'security':
        return 'Remind your customer to begin their security checks';
    }
  };

  return (
    <div className="mt-s flex flex-col gap-s bg-primary-10 px-xl py-l text-secondary-95">
      <div className="text-l font-bold">Actions you can take</div>
      <div className="text-m font-reg">{getText()}</div>
    </div>
  );
};
